import axios from "axios";

const BASE_URL = process.env.NEXT_PUBLIC_API_URL || process.env.API_URL

const axiosApp = axios.create({
  baseURL: BASE_URL
})

axiosApp.interceptors.request.use(
  (config) => {
    if(!!config.headers['Content-Type']){
      config.headers['Content-Type'] = 'application/json';
      config.headers['Accept'] = 'application/json';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error)
  }
);

axiosApp.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error)
  }
);

const buildUrlWithSearchParams = (url, params) => {
  if (!params || Object.keys(params).length === 0) return url;
  
  let result = "";

  Object.keys(params).forEach((key, i) => {
    if (!params[key]) {
      delete params[key];
    } else {
      if(i === 0) {
        result += `${key}=${params[key]}`
      } else {
        result += `&${key}=${params[key]}`
      }
    }
  });

  return `${url}?${result}`;
};

const getApi = async (
  requestUrl = "",
  params = {},
  options = {}
) => {

  try {
    let url = buildUrlWithSearchParams(requestUrl, params);

    let response = await axiosApp.get(`${BASE_URL}/${url}`, options);

    return response;
  } catch (error) {
    console.error('Error:', error);
    
    return Promise.reject(error);
  }
}

const postApi = async (
  requestUrl = "",
  body = {},
  params = {},
  options = {}
) => {

  try {
    let url = buildUrlWithSearchParams(requestUrl, params);

    let response = await axiosApp.post(`${BASE_URL}/${url}`, body, options);

    return response;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export { getApi, postApi }

export default axiosApp;
